<script setup lang="ts">
import { defineProps, ref, defineEmits } from "vue";
type Props = {
  title: string;
  options?: any;
  isError?: boolean;
  errorMessage?: string;
  modelValue: string;
};

type Emits = {
  (event: "update:modelValue", option: string): void;
};

const props = defineProps<Props>();

const emits = defineEmits<Emits>();

const selectModel = ref(props.modelValue ? props.modelValue : "");

const optionsVisible = ref(false);

const toggleOptionsHandler = () => {
  optionsVisible.value = !optionsVisible.value;
};

const selectedOptionHandler = (option: string) => {
  selectModel.value = option;
  optionsVisible.value = false;
  emits("update:modelValue", option);
};
</script>

<template>
  <div>
    <h4
      class="text-base leading-[26px] tracking-[0.01rem] font-medium text-[#898790]"
    >
      {{ title }}
    </h4>
    <div
      class="w-full bg-[#F9F8F6] border rounded-primary-radius mt-1"
      :class="` ${isError ? 'border-[#ED857F]' : ''} 
          ${!isError && !selectModel ? 'border-[#E3E1EA]' : ''} 
          ${selectModel && selectModel.length > 0 ? 'border-[#393840]' : ''} `"
    >
      <!-- Select -->
      <div
        @click="toggleOptionsHandler"
        class="w-full flex items-center justify-between p-3 h-[50px] cursor-pointer"
      >
        <input
          class="w-full outline-none bg-transparent text-black placeholder:text-[#898790] cursor-pointer"
          type="text"
          readonly
          placeholder="Select"
          v-model="selectModel"
        />
        <img src="@/assets/select-menu-arrow.svg" alt="Arrow down" />
      </div>

      <!-- Options -->
      <div v-if="optionsVisible">
        <ul
          class="options list-none flex flex-col items-start p-3"
          :class="options && options.length !== 0 ? 'p-3 pt-0' : 'p-0'"
        >
          <li
            @click="selectedOptionHandler(option.name)"
            v-for="option in options"
            :key="option.id"
            class="w-full text-base leading-[26px] tracking-[0.01rem] font-medium text-[#898790] hover:bg-[#e5e4e2] cursor-pointer hover:pl-[8px] rounded-lg duration-200"
            :class="option ? 'pl-0 pr-[5px] py-[10px]' : 'p-0'"
          >
            {{ option.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="flex gap-1 items-center mt-1" v-if="isError">
      <img src="@/assets/warning-red.svg" alt="Warning" />
      <span class="text-[#ed857f] text-sm">{{ errorMessage }}</span>
    </div>
  </div>
</template>
